<!-- App.vue -->
<template>
  <div id="app">
 
    
    <!-- 路由视图占位符 -->
    <router-view></router-view>

  </div>

</template>

<script setup>

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 640px;
  margin: 20px auto;
  overflow-y: hidden;
}

/* 手机端样式，屏幕宽度小于等于 768px 时应用 */
@media screen and (max-width: 768px) {
   
    #app {
    width: 100%;

}
}

/* App.vue 的 <style> 块 */
body {
  margin: 0 !important; /* 强制覆盖所有可能的默认边距 */
 
  
}

html, body {
  height: 100%; /* 确保充满视口 */
  overflow: hidden; /* 隐藏外层滚动条 */
}


</style>